
import { defineComponent, reactive, ref } from 'vue'
import Swiper from '@/components/swiper.vue'
import { useRouter } from 'vue-router'
import { getSingleProduct, postCart, getReview, postReview } from '@/api'
import { Product } from '@/api/product'
import { useToast } from 'vue-toastification'
import { useStore } from 'vuex'
import { UserInfo } from '@/store'
import { ReviewData } from '@/api/review'
// import { UserInfo } from '@/store'
// import { RecentCarousel } from '@/components/carousel.vue'
import Button from '@/components/btn.vue'
// import { useStore } from 'vuex'
// import bus from '@/plugins/bus'
export interface Review {
  _id: string;
  product: string;
  review: string;
  rating: number;
  user: UserInfo;
  createdAt: string;
  id?: string;
}
export default defineComponent({
  components: {
    Button,
    Swiper
  },
  setup () {
    const toast = useToast()
    const router = useRouter()
    const store = useStore()
    const review = ref('')
    const reviewList = ref([] as Review[])
    const reviewPage = ref(1)
    const productCount = ref(1)
    const pageContent = reactive({ data: {} as Product })
    const rateDecide = ref(false)
    const rating = ref(0)
    const loadReview = async () => {
      try {
        const res = await getReview(router.currentRoute.value.params.id as string, reviewPage.value)
        if (res.status === 200) {
          reviewList.value = res.data.data
        }
      } catch (error) {
        toast.error(error.response.data.message)
      }
    }
    const leaveReview = async () => {
      const data: ReviewData = {
        product: router.currentRoute.value.params.id as string,
        review: review.value,
        rating: rating.value
      }
      try {
        const res = await postReview(data)
        if (res.status === 201) {
          toast.success('review posted')
          loadReview()
        }
      } catch (error) {
        toast.error(error.response.data.message)
      }
    }
    const hoverStar = (count: number) => {
      if (rateDecide.value) return
      rating.value = count
    }
    const decideRate = (bool: boolean, count: number) => {
      rating.value = count
      rateDecide.value = bool
    }
    const addCount = () => {
      if (productCount.value >= 10) return toast.info('Reach the limit')
      productCount.value++
    }
    const minusCount = () => {
      if (productCount.value === 0) return toast.info('Cannot set less than 0')
      productCount.value--
    }
    const getProduct = async () => {
      const res = await getSingleProduct(router.currentRoute.value.params.id as string)
      if (res.status === 200) {
        pageContent.data = res.data.data
      }
    }
    const addBag = async (id: string) => {
      const data = {
        product: id,
        quantity: productCount.value
      }
      try {
        const res = await postCart(data)
        if (res.status === 200) {
          await store.dispatch('Check')
          toast.success('item added')
        }
      } catch (error) {
        toast.error(error.response.data.message)
      }
    }
    getProduct()
    loadReview()
    return {
      pageContent,
      productCount,
      addCount,
      minusCount,
      addBag,
      hoverStar,
      rating,
      decideRate,
      review,
      reviewList,
      leaveReview
    }
  }
})
